module.exports = __webpack_public_path__ + "static/media/icon_reward_copper.31fa40d1.svg";